/* React */
import React from "react";

/* Components */
import SearchbarContainer from "src/components/glossary/toolbar/searchbar-container/SearchbarContainer";

/* Stylesheet */
import styles from "./Toolbar.module.scss";

const Toolbar: React.FC = () => {
  return (
    <div className={styles.toolbar}>
      <SearchbarContainer />
    </div>
  );
};

export default Toolbar;
